function responsiveTabs(id, type) {

    const tabs = id;

    if ( tabs.length ) {
        tabs.easyResponsiveTabs({
            type                            : type,
            tabidentify                     : '_responsive-tabs',
            activetab_bg                    : 'transparent',
            inactive_bg                     : 'transparent',
            active_border_color             : 'transparent',
            active_content_border_color     : 'transparent'
        });
    }
}